export const NANO_DROP_KANBAN_LABELS = {
  pageTitle: 'Nano Drop',
  pagePlaceholder:
    'Kanban dedicado em construção. Os cards abaixo usam dados de exemplo para validação de UI.',
  orderTypeLabel: 'Nano Drop',
  deliverToday: 'Entregar hoje',
  deliverTomorrow: 'Entregar amanhã',
  leaveForDelivery: 'Sair para entrega',
  invoiceSent: 'Nota Fiscal enviada',
  invoiceNotSent: 'Nota Fiscal não enviada',
} as const

export type NanoDropKanbanLabels = typeof NANO_DROP_KANBAN_LABELS
